module.exports = __webpack_public_path__ + "static/media/olake-product-6.28dd5abf.svg";